<div class="p-5">
  <div #divForPDF class="col-md-12 center">
    <div class="col-md-12 row-no-margin">
      <div class="left " style="width:50%;">
        <span class="itemsummary-header" style="font-size:xx-large;">{{Actuator.Name}} {{Motor.Name}} {{Feedback.Code}}{{BrakeSelected ? "B" : "N"}}</span>
        <br />
        <span class="itemsummary-header" style="font-size:x-large;">{{Drive.MFG.Name}} {{Drive.Series}}</span>
      </div>
      <div class="right " style="width:50%;">
        <button class="thin-button " (click)="MotorData_Click()" >Motor Data<fa-icon [icon]="faArrowRight" class="rotate-45"></fa-icon></button>
        <button class="thin-button" (click)="FeedbackData_Click()">Feedback Data<fa-icon [icon]="faArrowRight" class="rotate-45"></fa-icon></button>
      </div>
    </div>
    <div class="col-md-12 button-container left">
      <button (click)="GeneratePDF()" class="thin-button" style="background-color: rgb(250, 82, 82); border-color: rgb(250, 82, 82); color: white;">Print to PDF<fa-icon [icon]="faFilePDF"></fa-icon></button>
      <button (click)="ExportToExcel()" class="thin-button" style="background-color: rgb(12, 166, 120); border-color: rgb(12, 166, 120); color: white; " >Excel<fa-icon [icon]="faFileExcel"></fa-icon></button>
      <!--<button class="thin-button" style="background-color: rgb(66, 99, 235); border-color: rgb(66, 99, 235); color: white; ">CMF File<fa-icon [icon]="faGear"></fa-icon></button>-->
      <!--<button (click)="DriveStartup_Click()" class="thin-button" style="background-color: black; border-color: black; color: white;" >Drive Startup<fa-icon [icon]="faBolt"></fa-icon></button>-->
    </div>
    <div class="col-md-12 row-no-margin" [hidden]="Connectors.length <= 1">
      
      <div class="col-md-12 left" [hidden]="HideSuggestedCables">
        <i>Suggested Power Cable:</i><b> {{GetSpecificCable('Power').MFG.Name}} {{GetSpecificCable('Power').Name}}</b>
        <br />
        <i>Suggested Feedback Cable:</i><b> {{GetSpecificCable('Feedback').MFG.Name}} {{GetSpecificCable('Feedback').Name}}</b>
      </div>
      <div class="col-md-12 row-no-margin left">
        <!--Power Cable-->
        <div class="col-md-7">
          <span class="fw-bold fs-2" >Actuator Power {{HideSuggestedCables ? "Cable" : "Connector"}}</span>
          <br />
          <span class="fs-3"><b>Manufacturer:</b> {{GetSpecificConnector('Power').Manufacturer.Name}}</span>
          <br />
          <span class="fs-3"><b>Part Number:</b> {{GetSpecificConnector('Power').ConnectorPN}}</span>
          <div class="connector-img-cont">
            <img src="./assets/images/{{PowerCableImage}}" alt="power cable" />
          </div>
        </div>
        <div class="col-md-4">
          <table class="pinTable" style="width:100%;">
            <tr>
              <th style="width:50%;">Pin</th>
              <th style="width:50%;">Signal</th>
            </tr>
            @for(pin of GetSpecificConnector('Power').Pins;track pin){
            <tr>
              <td>{{pin.PinID}}</td>
              <td>{{pin.Signal}}</td>
            </tr>
            }

          </table>
        </div>
      </div>
      <div class="col-md-12 row-no-margin left">
        <!--Feedback Cable-->
        <div class="col-md-7">
          <span class="fw-bold fs-2">Actuator Feedback {{HideSuggestedCables ? "Cable" : "Connector"}}</span>
          <br />
          <span class="fs-3"><b>Manufacturer:</b> {{GetSpecificConnector('Feedback').Manufacturer.Name}}</span>
          <br />
          <span class="fs-3"><b>Part Number:</b> {{GetSpecificConnector('Feedback').ConnectorPN}}</span>
          <div class="connector-img-cont">
            <img src="./assets/images/{{FeedbackCableImage}}" alt="feedback cable" />
          </div>
        </div>
        <div class="col-md-4">
          <table class="pinTable" style="width:100%;">
            <tr>
              <th style="width:50%;">Pin</th>
              <th style="width:50%;">Signal</th>
            </tr>
            @for(pin of GetSpecificConnector('Feedback').Pins;track pin){
            <tr>
              <td>{{pin.PinID}}</td>
              <td>{{pin.Signal}}</td>
            </tr>
            }

          </table>
        </div>
      </div>
    </div>

    <div class="col-md-12 row-no-margin" [hidden]="Connectors.length != 1">
      <div class="col-md-12 left" [hidden]="HideSuggestedCables">
        <i>Suggested Hybrid Cable:</i><b> {{GetSpecificCable('Hybrid').MFG.Name}} {{GetSpecificCable('Hybrid').Name}}</b>
      </div>
      <div class="col-md-12 left" [hidden]="Feedback.Code != 'CA2A2' && Feedback.Code != 'CT2A2'">
        <i>Suggested Hybrid Cable:</i><b> Contact Tolomatic</b>
      </div>
      <!--Hybrid Cable-->
      <div class="col-md-7 left">
        <span class="fw-bold fs-2">Actuator Hybrid {{HideSuggestedCables && Feedback.Code != 'CA2A2' && Feedback.Code != 'CT2A2' ? "Cable" : "Connector"}}</span>
        <br />
        <span class="fs-3"><b>Manufacturer:</b> {{GetSpecificConnector('Hybrid').Manufacturer.Name}}</span>
        <br />
        <span class="fs-3"><b>Part Number:</b> {{GetSpecificConnector('Hybrid').ConnectorPN}}</span>
        <div class="connector-img-cont">
          <img src="./assets/images/{{HybridCableImage}}" alt="hybrid cable" />
        </div>
      </div>
      <div class="col-md-4">
        <table class="pinTable" style="width:100%;">
          <tr>
            <th>Pin</th>
            <th>Signal</th>
          </tr>
          @for(pin of GetSpecificConnector('Hybrid').Pins;track pin){
          <tr>
            <td>{{pin.PinID}}</td>
            <td>{{pin.Signal}}</td>
          </tr>
          }

        </table>
      </div>
    </div>
  </div>
</div>

